// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CommonHeading from "../../components/commonComponents/commonHeading";
import CommonBreadcrumbs from "../../components/commonComponents/CommonBreadcrumbs";
import ButtonComponents from "../../components/commonComponents/ButtonComponents";
import TextFieldComponent from "../../components/commonComponents/TextFieldComponent";
import FundsBlock from "./FundsBlock";
import { useDispatch, useSelector } from "react-redux";
import { fetchAccountData } from "../../redux/slice/ledgerSlice";
import { useNavigate } from "react-router-dom";
import BankAccountRadioGroup from "../../components/BankAccountRadioGroup";
import { handleFetchApi } from "../../utils/api";
import { useAuth } from "../../services/AuthContext";
import { PlaidLink } from "react-plaid-link";
import { linkAccount } from "../../redux/slice/accountSlice";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import uploadDone from "../../assets/uploadGreen.png";
import trash from "../../assets/trash.png";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import loader from "../../assets/loading.png";
import {
  addFund,
  addWireFund,
  getFund,
  getTransactionHistory,
  setReduxLoading,
} from "../../redux/slice/fundAndTransactionSlice";
import NumberFormatter from "../../utils/NumberFormater";
import { generateGUID, numberToWords } from "../../utils/formatUtils";
import { textColor } from "../../utils/commonstyle";
import Copy from "../../assets/copy.png";

import wallet from "../../assets/wallet.svg";
import { paymentMasterDetails } from "../../redux/slice/businessSlice";
import { getInvestorApiUrl } from "../../utils/config";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import { BackButton } from "../../components/commonComponents/BackButton";
const AddFunds = () => {
  const [amount, setAmount] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [file, setFiles] = useState({}); // State for uploaded files
  const [selectedId, setSelectedId] = useState("");
  const { investorId: user } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [modelOpen, setModelOpen] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const inputRef = useRef();
  const [displayAmount, setDisplayAmount] = useState("");
  const [rawAmount, setRawAmount] = useState("");
  
  const fetchPayment = async () => {
    setLoading(true);
    const response = await dispatch(
      paymentMasterDetails("bank-details")
    ).unwrap();
    const filteredData = response.body.filter(item => 
      !item.columnName.toLowerCase().includes("escrow")
    );
    
    // Now set the filtered data
    setPaymentData(filteredData);
    setLoading(false);
  };

  const handleAccountChange = (event) => {
    setError("");
    setSelectedId(event.target.value);
  };

  const handleAmountChange = (event) => {
    const input = event.target;
    const value = input.value;
    const cursorPosition = input.selectionStart;

    // Remove all non-digits to get the raw value
    const rawValue = value.replace(/[^0-9]/g, "");

    // If the input is empty, clear both states
    if (!rawValue) {
      setAmount(null);
      setDisplayAmount("");
      setRawAmount("");
      return;
    }

    // Count digits before the cursor in the old value
    let digitsBeforeCursor = 0;
    for (let i = 0; i < cursorPosition; i++) {
      if (/\d/.test(value[i])) digitsBeforeCursor++;
    }

    // Format the number with commas for display
    console.log(rawValue, "rawValue")
    const formattedValue = new Intl.NumberFormat("en-US").format(Number(rawValue));
    console.log(formattedValue, "formattedValue")
    // Update states
    setAmount(formattedValue);
    setDisplayAmount(formattedValue);
    setRawAmount(rawValue);

    // Find the new cursor position: after the same number of digits
    let newCursor = 0, digitCount = 0;
    while (newCursor < formattedValue.length && digitCount < digitsBeforeCursor) {
      if (/\d/.test(formattedValue[newCursor])) digitCount++;
      newCursor++;
    }

    // Set cursor position after React updates the DOM
    setTimeout(() => {
      const inputElement = inputRef.current?.querySelector('input') || input;
      if (inputElement) {
        inputElement.setSelectionRange(newCursor, newCursor);
      }
    }, 0);
  };

  useEffect(() => {
    fetchPayment();
  }, []);


  const handleAddFunds = async () => {
    try {
      const newGUID = generateGUID();

      const addAmount = rawAmount && parseInt(rawAmount);
      if (addAmount > 0) {
        const formData = new FormData();
        formData.append("DepositReceipt", file);
        setModelOpen(true);
        const payload = {
          investorId: user.investorId,
          amount: addAmount,
          formData,
        };
        const response = await dispatch(addWireFund(payload)).unwrap();
        if (response.statusCode === 200) {
          dispatch(getTransactionHistory(user.investorId));
          dispatch(getFund(user.investorId));
        }
      } else {
        setError("");
        dispatch(setReduxLoading(false));
      }
    } catch (error) {
      console.error(error);
      if (error?.body) {
        if (error?.body?.message) {
          return;
        } else {
          setError(error?.body);
        }
        const id = setTimeout(() => {
          setError("");
        }, 5000);
        return () => {
          clearTimeout(id);
        };
      }
    }
  };

  const handleClose = () => {
    setModelOpen(false);
    setAmount(null);
    setDisplayAmount("");
    setRawAmount("");
    navigate("/managefunds", { state: { redirected: true } });
  };
  const appBreadCrumbs = [
    {
      href: "",
      label: "Home",
      onClick: () => {
        navigate("/home");
      },
    },
    {
      href: "",
      label: "Manage Funds",
      onClick: () => {
        navigate("/managefunds");
      },
    },
  ];

  const handleClick = () => {
    document.getElementById("type")?.click();
  };

  const handleDragOver = (event: React.DragEvent<HTMLElement>) => {
    event.preventDefault();
  };
  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
  };

  const handleDrop = (event: React.DragEvent<HTMLElement>) => {
    event.preventDefault();
    const uploadedFiles = Array.from(event.dataTransfer.files);
    if (uploadedFiles.length) {
      const changeEvent = {
        target: { files: uploadedFiles },
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      handleFileChange(changeEvent, "type");
    }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const uploadedFile = event.target.files ? event.target.files[0] : null;

    if (!uploadedFile) return; // Early return if no file is selected

    // Check file type
    const allowedFileTypes = ['.jpg', '.jpeg', '.png', '.pdf'];
    const fileExtension = '.' + uploadedFile.name.split('.').pop()?.toLowerCase();
    if (!allowedFileTypes.includes(fileExtension)) {
      toast.error(`File type ${fileExtension} is not allowed. Please upload only ${allowedFileTypes.join(', ')} files.`, {
        className: 'custom-toast'
      });
      event.target.value = '';
      return;
    }

    // Check if the file size exceeds the limit (e.g., 5MB)
    if (uploadedFile.size > 5 * 1024 * 1024) {
      // 5MB limit
      toast.error("The uploaded file exceeds the maximum allowed size of 5 MB. Please upload a smaller file.", {
        className: 'custom-toast'
      });
      event.target.value = '';
      return;
    }

    // Set the selected file
    setFiles(uploadedFile);
  };

  return (
    <>
    <div className='flex justify-start items-center'>
    <BackButton/>
    </div>
      <Box bgcolor={"#f8f8f8"} className="space-y-5">
        <div>
          <CommonHeading  sx={{ mb: 1,mt:{sm:3,md:0,xs:1} }}heading={"Add Funds"} />
          <CommonBreadcrumbs
            items={appBreadCrumbs}
            final={{
              href: "",
              label: "Wire Transfer",
              onClick: () => {
                console.log("Manage Funds clicked");
              },
            }}
          />
        </div>

        <FundsBlock />
        <Box
          sx={{
            // maxWidth: { xs: "100%", md: "45%" },
            mx: "auto",
            my: 1.5,
            display: "flex",
            flexDirection: "column",
            minHeight: { xs: "80vh", md: "33.2rem" },
            bgcolor: textColor.light,
            p: 4,
            // borderRadius: 2,
            color: textColor.fontColor,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "1.25rem", md: 16 },
              color: textColor.fontColor,
              mb: 1,
              fontWeight: 600,
            }}
          >
            Add Funds
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "1rem", md: 16 },
              color: textColor.fontColor,
              mb: 1,
              fontWeight: 400,
            }}
          >
            In order to add funds to your xBid account, please wire transfer to
            the account listed below. Once done, provide details of the
            transaction in the next section{" "}
          </Typography>
          <Box
            style={{ fontWeight: 500 }}
            fontSize={17}
            color={textColor.fontColor}
          >
            <span style={{ fontWeight: 700 }}> Step 1 </span>: Bank details for
            wire transfer
          </Box>
          <Box my={1}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "7px" }}>
              {loading ? (
                <Loading height={"250px"} />
              ) : (
                paymentData.map((bank, index) => (
                  <div
                    key={index}
                    className="w-full md:w-[calc(50%-8px)]"
                    style={{
                      // width: "calc(50% - 8px)", // Adjusted to divide into two equal parts
                      display: "flex", // Ensure content inside is aligned
                      justifyContent: "space-between", // Space between label and value
                      marginBottom: "8px", // Add some margin to separate rows
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: "400", color: "#9FA4AB" }}
                      variant="body1"
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between", // Ensures the content is split equally
                        alignItems: "center", // Align items vertically
                      }}
                    >
                      <Box
                        sx={{
                          width: { md: "30%" },
                          fontWeight: 500,
                          textAlign: "left",
                        }}
                      >
                        {bank.columnName}
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "50%",
                          // justifyContent: "space-between", // Align content properly even if no icon
                        }}
                      >
                        <span
                          style={{
                            color: "#3B3B3B",
                            fontWeight: 500,
                            textAlign: "left",
                            // width: "50%",
                            // marginRight: "8px", // Small margin between the value and icon
                          }}
                        >
                          : {bank.columnValues}
                        </span>
                        {(bank.columnName === "Bank Name") |
                        (bank.columnName === "ABA Routing Number") |
                        (bank.columnName === "Account Number") ? (
                          <IconButton
                            onClick={() => handleCopy(bank.columnValues)}
                            size="small"
                            sx={{ marginRight: "auto" }}
                          >
                            <img
                              src={Copy}
                              alt="copy icon"
                              height={20}
                              width={20}
                            />
                          </IconButton>
                        ) : (
                          <div style={{ width: "20px" }} /> // Leave space when no copy icon
                        )}
                      </Box>
                    </Typography>
                  </div>
                ))
              )}
            </div>
          </Box>
          <Divider sx={{ mb: 3 }} />
          <Box
            style={{ fontWeight: 500 }}
            fontSize={17}
            color={textColor.fontColor}
          >
            <span style={{ fontWeight: 700 }}> Step 2 </span>: Enter wire
            transfer details
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "1rem", md: 16 },
              color: textColor.fontColor,
              mb: 1,
              fontWeight: 400,
              // textAlign: "center",
            }}
          >
            If you completed the wire transfer, enter the value and upload proof
            of wire transfer confirmation. We will verify the transaction and
            notify you within 2 business days
          </Typography>
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Amount Transferred"
              value={amount}
              onChange={handleAmountChange}
              error={error}
              helperText={
                error ? "Please enter a valid amount greater than $0" : ""
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box
                      sx={{
                        marginBottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: 45,
                        width: 22,
                        borderRadius: "4px",
                      }}
                    >
                      <Typography sx={{ fontSize: "1.2rem" }}>$</Typography>
                    </Box>
                  </InputAdornment>
                ),
              }}
              sx={{
                // mb: 3,
                height: 54,
                mb: 0,
                fontWeight: 700,
                "& input": {
                  fontWeight: 600,
                  bgcolor: "#fff",
                  ml: "2px",
                  pl: 1,
                },
                "&.MuiFormControl-root label": {
                  color: textColor.fontColor,
                  // ml: 2
                },
                backgroundColor: "#f9f9f9",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#ccc",
                  },
                  "&:hover fieldset": {
                    borderColor: "#999",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#666",
                  },
                },
                "& .MuiFormHelperText-root": {
                  fontSize: "0.75rem", // Ensure it matches the default height (or adjust based on your need)
                  height: 25, // Set the height of the helper text
                  marginTop: "4px", // Optionally adjust margin to align with the input box
                },
              }}
            />
            <Typography
            sx={{
              fontSize: "12px",
              color: textColor.fontColor,
              fontWeight: 400,
              mt: "3px",
              minHeight: 10,
              maxHeight: 30,
              textAlign: "left",
              fontStyle: "italic",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {numberToWords(amount?.replace(/,/g, ""))}
            {amount?.replace(/,/g, "") > 0 && " dollars"}
          </Typography>
          </Box>
          {!file?.name ? (
            <Box
              onClick={handleClick}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              sx={{
                border: `2px dashed ${textColor.borderColor}`,
                borderRadius: "8px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <input
                type="file"
                id={"type"}
                accept=".jpeg,.png,.pdf"
                hidden
                // style={{ display: "none" }}
                onChange={(e) => handleFileChange(e)}
                // onDrop={handleFileChange}
                // onDragEnd={handleFileChange}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              />
              <IconButton sx={{ backgroundColor: "#F5F5F5", my: 1 }}>
                <CloudUploadOutlinedIcon
                  sx={{ color: "#FF5C39", fontSize: "24px" }}
                />
              </IconButton>
              <Typography
                fontSize={17}
                fontWeight={500}
                my={1}
                px={1}
                color={textColor.fontColor}
              >
                Click to upload wire transfer receipt OR Drag & drop it here
              </Typography>
              <Typography
                fontSize={14}
                fontWeight={400}
                mb={3}
                color={textColor.fontColor}
              >
                .jpeg, .png, or .pdf. Maximum 5MB.{" "}
              </Typography>
            </Box>
          ) : (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              bgcolor={textColor.secondaryColor}
              mb={1}
              p={1}
              borderRadius="4px"
            >
              <Typography fontSize={14} color="text.secondary">
                {file.name} ({(file.size / 1024).toFixed(2)} KB)
              </Typography>
              <Box sx={{ display: "flex", gap: 2, fontSize: 14 , width:'9rem'}}>
                <img src={uploadDone} alt="upload" width={20} height={20} />
                Uploaded
                <div
                  onClick={() => {
                    setFiles({});
                  }}
                >
                  <img src={trash} alt="upload" width={20} height={20} />
                </div>
              </Box>
            </Box>
          )}
          <Box textAlign="center">
            <Box
              display={"flex"}
              mt={{ xs: 2, md: 0 }}
              justifyContent={{ xs: "center", md: "end" }}
            >
              <ButtonComponents
                variant="contained"
                sx={{ borderRadius: 2, mr: 0, my: 1, fontSize: "16px" }}
                disabled={
                  file.name &&
                  amount &&
                  parseInt(amount?.replace(/[^0-9.]/g, ""))
                    ? false
                    : true
                }
                label={"Submit"}
                onClick={handleAddFunds}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Dialog
        open={modelOpen}
        sx={{
          zIndex:"9999999",
        }}
        maxWidth={"sm"}
        // sx={{width:100}}
        onClose={() => {}}
      >
        <DialogContent
          sx={{ padding: "25px", paddingTop: "30px", fontWeight: 500 }}
        >
          <DialogContentText
            textAlign={"center"}
            fontWeight={"500"}
            sx={{ color: "#3b3b3b" }}
          >
            <div className=" flex justify-center pb-4">
              <ErrorOutlineIcon sx={{ color: "#FF5C39", rotate: "180deg" }} />
            </div>
            <h5 className="text-2xl font-medium mb-3 text-[#FF5C39]">
              Transaction Submitted!
            </h5>
            Your wire transfer receipt has been uploaded successfully.
            <br />
            We will verify the transaction and notify you within 2 business days
          </DialogContentText>
          <DialogActions sx={{ justifyContent: "center", p: 0 }}>
            <ButtonComponents
              label={"OK"}
              sx={{ mt: 1.5, fontSize: "16px" }}
              onClick={handleClose}
            />
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddFunds;